// extracted by mini-css-extract-plugin
export default {"wrapper":"RcE_ymdV","icon":"VfUAIUD5","textHighlighting":"FRB_rdKO","hint":"fTreuayL","draggerProgress":"KWnWXMlW","dragger":"mRwyZdZk"};